/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AdmissionDetails } from './AdmissionDetails';
import {
    AdmissionDetailsFromJSON,
    AdmissionDetailsFromJSONTyped,
    AdmissionDetailsToJSON,
} from './AdmissionDetails';
import type { IntegrationEventPccPatient } from './IntegrationEventPccPatient';
import {
    IntegrationEventPccPatientFromJSON,
    IntegrationEventPccPatientFromJSONTyped,
    IntegrationEventPccPatientToJSON,
} from './IntegrationEventPccPatient';
import type { IntegrationEventTooltips } from './IntegrationEventTooltips';
import {
    IntegrationEventTooltipsFromJSON,
    IntegrationEventTooltipsFromJSONTyped,
    IntegrationEventTooltipsToJSON,
} from './IntegrationEventTooltips';
import type { PccAdmissionRecord } from './PccAdmissionRecord';
import {
    PccAdmissionRecordFromJSON,
    PccAdmissionRecordFromJSONTyped,
    PccAdmissionRecordToJSON,
} from './PccAdmissionRecord';

/**
 * 
 * @export
 * @interface IntegrationEvent
 */
export interface IntegrationEvent {
    /**
     * 
     * @type {number}
     * @memberof IntegrationEvent
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IntegrationEvent
     */
    facility_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IntegrationEvent
     */
    integration_patient_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationEvent
     */
    actioned?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IntegrationEvent
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationEvent
     */
    integration?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationEvent
     */
    event_type?: string;
    /**
     * 
     * @type {object}
     * @memberof IntegrationEvent
     */
    event_payload?: object;
    /**
     * 
     * @type {object}
     * @memberof IntegrationEvent
     */
    fetched_data?: object;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationEvent
     */
    auto_applied?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IntegrationEvent
     */
    actioned_by_user_id?: number;
    /**
     *
     * @type {string}
     * @memberof IntegrationEvent
     */
    action_source?: 'manual' | 'automatic' | null;
    /**
     *
     * @type {string}
     * @memberof IntegrationEvent
     */
    actioned_by_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IntegrationEvent
     */
    actioned_at?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationEvent
     * @deprecated
     */
    processor_outcome_reason?: string;
    /**
     *
     * @type {string}
     * @memberof IntegrationEvent
     */
    processor_outcome?: IntegrationEventProcessorOutcomeEnum;
    /**
     *
     * @type {string}
     * @memberof IntegrationEvent
     */
    display_outcome_reason?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationEvent
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationEvent
     */
    updatedAt?: string;
    /**
     * 
     * @type {IntegrationEventTooltips}
     * @memberof IntegrationEvent
     */
    tooltips?: IntegrationEventTooltips;
    /**
     * 
     * @type {IntegrationEventPccPatient}
     * @memberof IntegrationEvent
     */
    pcc_patient?: IntegrationEventPccPatient;
    /**
     * 
     * @type {AdmissionDetails}
     * @memberof IntegrationEvent
     */
    current_admission_details?: AdmissionDetails | null;
    /**
     * 
     * @type {AdmissionDetails}
     * @memberof IntegrationEvent
     */
    actioned_admission_details?: AdmissionDetails | null;
    /**
     *
     * @type {PccAdmissionRecord}
     * @memberof IntegrationEvent
     */
    integration_admission_status?: PccAdmissionRecord | null;
}


/**
 * @export
 */
export const IntegrationEventProcessorOutcomeEnum = {
    Applied: 'applied',
    NoOp: 'no_op',
    NeedsReview: 'needs_review',
    Stale: 'stale',
    Failed: 'failed'
} as const;
export type IntegrationEventProcessorOutcomeEnum = typeof IntegrationEventProcessorOutcomeEnum[keyof typeof IntegrationEventProcessorOutcomeEnum];


/**
 * Check if a given object implements the IntegrationEvent interface.
 */
export function instanceOfIntegrationEvent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IntegrationEventFromJSON(json: any): IntegrationEvent {
    return IntegrationEventFromJSONTyped(json, false);
}

export function IntegrationEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'facility_id': !exists(json, 'facility_id') ? undefined : json['facility_id'],
        'integration_patient_id': !exists(json, 'integration_patient_id') ? undefined : json['integration_patient_id'],
        'actioned': !exists(json, 'actioned') ? undefined : json['actioned'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'integration': !exists(json, 'integration') ? undefined : json['integration'],
        'event_type': !exists(json, 'event_type') ? undefined : json['event_type'],
        'event_payload': !exists(json, 'event_payload') ? undefined : json['event_payload'],
        'fetched_data': !exists(json, 'fetched_data') ? undefined : json['fetched_data'],
        'auto_applied': !exists(json, 'auto_applied') ? undefined : json['auto_applied'],
        'actioned_by_user_id': !exists(json, 'actioned_by_user_id') ? undefined : json['actioned_by_user_id'],
        'action_source': !exists(json, 'action_source') ? undefined : json['action_source'],
        'actioned_by_name': !exists(json, 'actioned_by_name') ? undefined : json['actioned_by_name'],
        'actioned_at': !exists(json, 'actioned_at') ? undefined : json['actioned_at'],
        'processor_outcome_reason': !exists(json, 'processor_outcome_reason') ? undefined : json['processor_outcome_reason'],
        'processor_outcome': !exists(json, 'processor_outcome') ? undefined : json['processor_outcome'],
        'display_outcome_reason': !exists(json, 'display_outcome_reason') ? undefined : json['display_outcome_reason'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'tooltips': !exists(json, 'tooltips') ? undefined : IntegrationEventTooltipsFromJSON(json['tooltips']),
        'pcc_patient': !exists(json, 'pcc_patient') ? undefined : IntegrationEventPccPatientFromJSON(json['pcc_patient']),
        'current_admission_details': !exists(json, 'current_admission_details') ? undefined : AdmissionDetailsFromJSON(json['current_admission_details']),
        'actioned_admission_details': !exists(json, 'actioned_admission_details') ? undefined : AdmissionDetailsFromJSON(json['actioned_admission_details']),
        'integration_admission_status': !exists(json, 'integration_admission_status') ? undefined : PccAdmissionRecordFromJSON(json['integration_admission_status']),
    };
}

export function IntegrationEventToJSON(value?: IntegrationEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'facility_id': value.facility_id,
        'integration_patient_id': value.integration_patient_id,
        'actioned': value.actioned,
        'state': value.state,
        'integration': value.integration,
        'event_type': value.event_type,
        'event_payload': value.event_payload,
        'fetched_data': value.fetched_data,
        'auto_applied': value.auto_applied,
        'actioned_by_user_id': value.actioned_by_user_id,
        'action_source': value.action_source,
        'actioned_by_name': value.actioned_by_name,
        'actioned_at': value.actioned_at,
        'processor_outcome_reason': value.processor_outcome_reason,
        'processor_outcome': value.processor_outcome,
        'display_outcome_reason': value.display_outcome_reason,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'tooltips': IntegrationEventTooltipsToJSON(value.tooltips),
        'pcc_patient': IntegrationEventPccPatientToJSON(value.pcc_patient),
        'current_admission_details': AdmissionDetailsToJSON(value.current_admission_details),
        'actioned_admission_details': AdmissionDetailsToJSON(value.actioned_admission_details),
        'integration_admission_status': PccAdmissionRecordToJSON(value.integration_admission_status),
    };
}
